/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  KillswitchMCPServer,
  KillswitchMCPServer$inboundSchema,
} from "./killswitchmcpserver.js";

export type KillswitchListMCPServersResult = {
  servers: Array<KillswitchMCPServer>;
};

/** @internal */
export const KillswitchListMCPServersResult$inboundSchema: z.ZodMiniType<
  KillswitchListMCPServersResult,
  unknown
> = z.object({
  servers: z.array(KillswitchMCPServer$inboundSchema),
});

export function killswitchListMCPServersResultFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchListMCPServersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchListMCPServersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchListMCPServersResult' from JSON`,
  );
}
